 export const JobsData = [
	{
		'id' : 'J1234',
		'jobTitle' : "Customer Service Advisor",
		'dateAdded' : '12/05/2017',
		'status': 'Active',
		'contactName' : 'Susan Ryan',
		'contactEmail' : 'susanryan@gmail.com',
		'candidateCount' : 12,
		'candidates' : [
		],
	},
	{
		'id' : 'J23544',
		'jobTitle' : "Customer Complains Officer",
		'dateAdded' : '20/12/2017',
		'status': 'Active',
		'contactName' : 'Joe Wilson',
		'contactEmail' : 'jobwilson@gmail.com',
		'candidateCount' : 0,
		'candidates' : [
		],
	}
]



// WEBPACK FOOTER //
// ./src/data/jobs.js